import { Box, type BoxProps } from '@chakra-ui/react'
import { LightSurface } from '../shared'

/**
 * A floating overlay island that sits on top of the always-light map surface.
 *
 * Wraps its content in {@link LightSurface} (design of record §5.6) so surface /
 * status panels — the unit scorecard, the desktop-tools notice — keep their LIGHT
 * tokens even while the app is in dark mode. Without this a dark-tokened panel
 * renders dark-on-light-map, which is the jarring case slice-7's gate-4 flagged.
 *
 * Positioning props (`position`, `top`/`right`/`bottom`/`left`, `zIndex`, width…)
 * are forwarded to the inner Box, so call-sites read like the plain positioned
 * `<Box>` they replace. The forced-light `<Theme>` wrapper is static-flow and does
 * not disturb the child's absolute positioning against the map's relative ancestor.
 */
export function MapOverlayIsland(props: BoxProps) {
  return (
    <LightSurface>
      <Box {...props} />
    </LightSurface>
  )
}
